/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanCommonNextMonthPlanDto
 */
export interface MonthPlanCommonNextMonthPlanDto {
  /**
   *
   * @type {number}
   * @memberof MonthPlanCommonNextMonthPlanDto
   */
  month: number;
  /**
   *
   * @type {number}
   * @memberof MonthPlanCommonNextMonthPlanDto
   */
  year: number;
  /**
   *
   * @type {Date}
   * @memberof MonthPlanCommonNextMonthPlanDto
   */
  from: Date;
  /**
   *
   * @type {Date}
   * @memberof MonthPlanCommonNextMonthPlanDto
   */
  to: Date;
}

export function MonthPlanCommonNextMonthPlanDtoFromJSON(json: any): MonthPlanCommonNextMonthPlanDto {
  return MonthPlanCommonNextMonthPlanDtoFromJSONTyped(json, false);
}

export function MonthPlanCommonNextMonthPlanDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanCommonNextMonthPlanDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    month: json["month"],
    year: json["year"],
    from: new Date(json["from"]),
    to: new Date(json["to"]),
  };
}

export function MonthPlanCommonNextMonthPlanDtoToJSON(value?: MonthPlanCommonNextMonthPlanDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    month: value.month,
    year: value.year,
    from: value.from.toISOString(),
    to: value.to.toISOString(),
  };
}
